import React from 'react';
import { observer } from 'mobx-react-lite';
import { getUrlFromPath } from 'libs/helpers/helper.lib';
import themeStore from 'stores/theme.store';

const DynamicLogo = ({ className, onClick, alt = 'Logo', ...props }) => {
  const themeConfig = themeStore.getThemeConfig();
  const darkLogoUrl = themeStore.getDarkLogoUrl();
  const lightLogoUrl = themeStore.getLightLogoUrl();
  
  // Determine which logo to use based on background color
  // If background is dark (low brightness), use light logo
  // If background is light (high brightness), use dark logo
  const isDarkBackground = themeConfig.color_background === '#000000' || 
                          themeConfig.color_background === '#121212' ||
                          themeConfig.color_background.startsWith('#') && 
                          parseInt(themeConfig.color_background.slice(1, 3), 16) < 128;
  
  const logoUrl = isDarkBackground ? lightLogoUrl : darkLogoUrl;

  return (
    <img
      src={getUrlFromPath(logoUrl)}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={(e) => {
        e.target.src = '/logo.png';
      }}
      {...props}
    />
  );
};

export default observer(DynamicLogo);
